export default "__VITE_ASSET__CSYZGYhZ__"